"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_SLOTS = exports.DESCRIPTIVE_TRANSCRIPT_HTML = exports.DESCRIPTIVE_TRANSCRIPT = exports.HOTSPOT = void 0;
exports.HOTSPOT = "hotspot";
exports.DESCRIPTIVE_TRANSCRIPT = "descriptive-transcript";
exports.DESCRIPTIVE_TRANSCRIPT_HTML = "descriptive-transcript-html";
exports.VALID_SLOTS = "$validSlots";
//# sourceMappingURL=consts.js.map